import * as React from "react"
import { Center, Flex } from "@chakra-ui/react"
import { HomeAvatarProps } from "./home.interface"
import { UserAvatar } from "../../common/avatar"
import { IoMdSwap } from "react-icons/io"
import { Icon } from "../../common/icons"
import { useRecoilValue, useRecoilState } from "recoil"
import { saveConfigAvatarAtom } from "../../../recoil/atoms/avatar"
import { brandingSelector } from "../../../recoil/atoms/room"
import { getUserTypeByUrl } from "../../../util/getUserTypeByUrl"
import { UserType } from "../../../types/user"
import { replaceOpacity, isRGBAcolor, addHexColorOpacity } from "../../../util"
import layoutStates from "../../../recoil/atoms/layout"

const _HomeAvatar: React.FC<HomeAvatarProps> = ({
  showMinifiedLables,
  openAvatarModal,
  isLandscape,
  isAndroidMobile,
  isMobile
}) => {
  const userTypeFromUrl = getUserTypeByUrl()
  const [showHeader] = useRecoilState(layoutStates.showHeader)
  const isModeratorType = React.useMemo(
    () => userTypeFromUrl === UserType.MODERATOR,
    [userTypeFromUrl]
  )
  const config = useRecoilValue(saveConfigAvatarAtom)
  const roomStyles = useRecoilValue(brandingSelector)
  const profileImageUrl =
    isModeratorType && roomStyles?.roomAvatarImage
      ? roomStyles.roomAvatarImage
      : ""
  return (
    showMinifiedLables && (
      <>
        <Center
          marginTop={
            isLandscape && !showHeader
              ? "0rem !important"
              : isLandscape && isAndroidMobile && "0.7rem !important"
          }
          marginBottom={
            isLandscape && !showHeader
              ? "0.6rem !important"
              : showHeader &&
                isLandscape &&
                (isAndroidMobile ? "0.7rem !important" : "0.7rem !important")
          }
        >
          <Flex position="relative">
            <UserAvatar
              bg={profileImageUrl ? "transperent" : "blackAlpha.900"}
              avatar={config}
              colorDisk="blackAlpha.900"
              avatarStyle={{ width: "3rem", height: "3rem" }}
              src={profileImageUrl}
            />
            <Flex
              bg={
                roomStyles?.joinButtonBackgroundColor
                  ? isRGBAcolor(roomStyles?.joinButtonBackgroundColor)
                    ? replaceOpacity(roomStyles?.joinButtonBackgroundColor, 0.7)
                    : addHexColorOpacity(
                        roomStyles?.joinButtonBackgroundColor,
                        0.7
                      )
                  : "gray.600"
              }
              border={`1px solid ${
                roomStyles?.joinButtonBorderColor ?? "gray.600"
              }`}
              position="absolute"
              width="25px"
              height="25px"
              borderRadius="50%"
              alignItems="center"
              justifyContent="center"
              bottom="-3px"
              onClick={openAvatarModal}
              right="-6px"
              cursor="pointer"
              color={roomStyles?.joinPageButtonTextColor ?? "white"}
              _hover={
                isMobile
                  ? {}
                  : {
                      backgroundColor:
                        roomStyles?.joinButtonMouseoverBackgroundColor ??
                        "#24A840",
                      textColor:
                        roomStyles?.joinPageButtonMouseoverTextColor ??
                        "#FFFFFF"
                    }
              }
            >
              <Icon src={IoMdSwap} />
            </Flex>
          </Flex>
        </Center>
        <br style={{ display: isLandscape ? "none" : "block" }} />
      </>
    )
  )
}

export const HomeAvatar = React.memo(_HomeAvatar)
